import React from "react";

const YoungEarnersUnder = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled gap-3 d-flex flex-column">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  1. Payments to customers under 18
                </h5>
                <ul className="info_description text-dark opacity-50">
                  <li>
                    Topcoin UK is open to customers of all ages. We believe in
                    rewarding loyalty for everyone, including young customers.
                    However, when it comes to releasing cash rewards from our
                    unlocked wallets, we follow a clear and responsible policy:
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">2. Participation</h5>
                <ul className="info_description text-dark opacity-50">
                  <li>
                    - Customers under the age of 18 can collect Topcoin UK, unlock milestones, and earn cash rewards.
                  </li>
                  <li>
                    - Participation requires a parent or guardian’s consent
                    during account registration.
                  </li>
                </ul>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  3. Receiving Cash Rewards
                </h5>
                <p className="info_description text-dark opacity-50 fw-bold mb-0">
                  When a customer under 18 unlocks a cash wallet, they have two
                  options:
                </p>
                <p>
                  <p className="info_description mt-2 text-dark opacity-50 fw-bold mb-0">
                    Option A ,Payment to Their Own Bank Account
                  </p>
                  <ul className="info_description my-3 text-dark opacity-50">
                    <li>
                      - If the customer holds a valid UK bank account in their
                      own name (youth account), Topcoin UK can transfer the cash
                      rewards directly to that account.{" "}
                    </li>
                    <li>
                      {" "}
                      The customer (or their parent/guardian) must provide
                      accurate account details and ensure their bank accepts the
                      transfer.{" "}
                    </li>
                    <li>
                      {" "}
                      Some youth accounts may have daily/monthly deposit limits.
                      It is the responsibility of the account holder to check
                      with their bank.
                    </li>
                  </ul>
                  <p className="info_description text-dark opacity-50 fw-bold mb-0">
                    Option B ,Payment to Parent/Guardian Bank Account
                  </p>
                  <ul className="info_description text-dark opacity-50">
                    <li>
                      If the customer does not have their own bank account, or
                      prefers this option, cash rewards will be transferred to
                      the parent/guardian’s nominated bank account.
                    </li>
                  </ul>
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  4. Consent & Verification
                </h5>

                <ul className="info_description text-dark opacity-50">
                  <li>
                    For all payments to customers under 18, Topcoin UK requires
                    confirmation of parental or guardian consent.
                  </li>
                  <li>
                    We may request proof of identity for both the customer and
                    the parent/guardian before releasing funds.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark"> 5. Responsibility </h5>

                <ul className="info_description text-dark opacity-50">
                  <li>
                    Topcoin UK acts as the holder of the cash rewards until the
                    eligible payment method is confirmed.
                  </li>
                  <li>
                    We are a loyalty and rewards program, not a bank, investment
                    platform, or gambling service. Our rewards do not accumulate
                    interest and cannot decrease in value.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  6. Cashing for individuals under 18{" "}
                </h5>

                <ul className="info_description text-dark opacity-50">
                  <li>
                    Customers under 18 are welcome to join the Topcoin UK
                    platform, collect TopCoin, and unlock rewards. However, when
                    it comes to cashing out from a cash wallet, we require
                    consent from a parent or guardian to ensure
                    responsible participation.
                  </li>                  
                </ul>
                <a
                      href="../../../parental_consent_form.pdf"
                      download className=" fw-bold text-decoration-underline text-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      download the Parental/Guardian Consent Form{" "}
                    </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YoungEarnersUnder;
